// Fase 14A — Scelta lingua al primo accesso (punto 9): mostrata solo se l'utente
// non ha ancora espresso una preferenza personale. Accessibile, nomi nativi.
import { useState } from "react";
import { Globe } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function FirstLanguageDialog() {
  const { user } = useAuth();
  const { languages, explicit, setLanguage } = useI18n();
  const [dismissed, setDismissed] = useState(false);
  const open = !!user && !explicit && !dismissed && languages.length > 1;

  const choose = async (code) => {
    await setLanguage(code);
    setDismissed(true);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && setDismissed(true)}>
      <DialogContent className="max-w-sm" data-testid="language-onboarding-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Globe className="w-5 h-5 text-green-700" aria-hidden="true" />
            Scegli la tua lingua · Choose your language
          </DialogTitle>
          <DialogDescription className="text-xs">
            Puoi cambiarla in qualsiasi momento. · You can change it anytime.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 py-2">
          {languages.map((l) => (
            <Button key={l.code} variant="outline" className="justify-start h-10"
              onClick={() => choose(l.code)}
              data-testid={`onboarding-language-${l.code}`}>
              {l.name}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
